import { createContext, useContext, ReactNode } from 'react';
import { useThemeMode, ThemeMode } from '@/hooks/useTheme';

type ThemeModeContextValue = {
  themeMode: ThemeMode;
  effectiveMode: 'light' | 'dark';
  setThemeMode: (mode: ThemeMode) => void;
  isLight: boolean;
  isDark: boolean;
  isAuto: boolean;
};

const ThemeModeContext = createContext<ThemeModeContextValue | undefined>(undefined);

export function ThemeModeProvider({ children }: { children: ReactNode }) {
  const { themeMode, effectiveMode, setThemeMode, isLight, isDark, isAuto } = useThemeMode();

  return (
    <ThemeModeContext.Provider
      value={{ themeMode, effectiveMode, setThemeMode, isLight, isDark, isAuto }}
    >
      {children}
    </ThemeModeContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useThemeModeContext() {
  const ctx = useContext(ThemeModeContext);
  if (!ctx) throw new Error('useThemeModeContext must be used within ThemeModeProvider');
  return ctx;
}

export default ThemeModeContext;
